exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bgg[data-v-7e4cb264]{background-color:#fff}", ""]);
